module.exports = __webpack_public_path__ + "img/icn-send.a33edb60.svg";